// extracted by mini-css-extract-plugin
module.exports = {"container":"SaleCountdown_container__MBeb2","text":"SaleCountdown_text__FkfH1","pulsatingCircle":"SaleCountdown_pulsatingCircle__o_DIO"};